import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Gift, Leaf, Activity, HeartHandshake, Headphones } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
const bonuses = [{
  icon: Leaf,
  title: 'Guía de Alimentación Antiinflamatoria',
  subtitle: 'Hábitos simples para sentirte mejor día a día.'
}, {
  icon: Activity,
  title: 'Rutina Diaria de Ejercicios',
  subtitle: 'Movimientos suaves y progresivos para recuperar confianza y movilidad.'
}, {
  icon: HeartHandshake,
  title: 'Guía Emocional para los Días Difíciles',
  subtitle: 'Herramientas para manejar el miedo, la frustración y el agotamiento mental.'
}, {
  icon: Headphones,
  title: '3 Meditaciones Guiadas',
  subtitle: 'Audios para acompañarte en los momentos más difíciles.'
}];
export function OfferSection() {
  return <section className="pt-24 pb-4 sm:pb-24 bg-sage/10 relative" data-id="element-170">
      <div className="max-w-4xl mx-auto px-2 sm:px-6" data-id="element-171">
        <FadeIn className="bg-white rounded-3xl p-4 sm:p-8 md:p-12 shadow-xl border border-sage/20 relative overflow-hidden" data-id="element-172">
          <div className="absolute top-0 right-0 w-64 h-64 bg-sage/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-173"></div>

          {/* Price */}
          <div className="relative z-10 text-center mb-10" data-id="element-174">
            <span className="text-xl text-warm-dark/40 line-through font-heading" data-id="element-175">
              $27 USD
            </span>
            <span className="text-5xl font-heading font-bold text-warm-dark block mt-1" data-id="element-176">
              $14.99 USD
            </span>
            <p className="text-sm text-warm-dark/50 mt-2 uppercase tracking-wider" data-id="element-177">
              Pago único
            </p>
          </div>

          {/* Primary CTA */}
          <div className="text-center space-y-4 mb-12" data-id="element-178">
            <Button href="https://pausaviva.com/cart/47287315398805:1" onClick={() => trackAddToCart({
            content_name: 'Espalda Libre Ebook',
            content_type: 'product',
            value: 14.99,
            currency: 'USD'
          })} className="w-full md:w-auto px-12 py-5 text-xl shadow-lg shadow-sage/30" data-id="element-179">
              Comprar Ebook Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-warm-dark/60" data-id="element-180">
              <ShieldCheck className="w-4 h-4" data-id="element-181" />
              <span data-id="element-182">Pago 100% seguro. Acceso inmediato.</span>
            </div>
          </div>

          {/* Bonuses heading */}
          <h3 className="relative z-10 font-heading text-2xl md:text-3xl text-warm-dark flex items-center justify-center gap-2 mb-8 text-center" data-id="element-183">
            <Gift className="w-6 h-6 text-warm-accent" data-id="element-184" />
            También recibirás Hoy
          </h3>

          {/* Individual premium bonus cards */}
          <div className="relative z-10 grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-185">
            {bonuses.map((bonus, i) => {
            const Icon = bonus.icon;
            return <FadeIn key={i} delay={i * 0.08} className="group relative bg-warm-bg rounded-2xl p-6 border border-warm-accent/10 overflow-hidden" data-id="element-186">
                  {/* decorative soft circle */}
                  <div className="absolute -top-6 -right-6 w-24 h-24 bg-sage/10 rounded-full" data-id="element-187" />

                  <div className="relative z-10 flex flex-col items-start" data-id="element-188">
                    <div className="w-14 h-14 rounded-2xl bg-sage/15 flex items-center justify-center mb-5" data-id="element-189">
                      <Icon className="w-7 h-7 text-sage" strokeWidth={1.5} data-id="element-190" />
                    </div>
                    <h4 className="font-heading text-lg md:text-xl text-warm-dark leading-snug mb-2" data-id="element-191">
                      {bonus.title}
                    </h4>
                    <p className="text-sm text-warm-dark/70 leading-relaxed" data-id="element-192">
                      {bonus.subtitle}
                    </p>
                  </div>

                  {/* subtle bottom accent */}
                  <div className="absolute bottom-0 left-0 h-1 w-full bg-warm-accent/20" data-id="element-193" />
                </FadeIn>;
          })}
          </div>
        </FadeIn>
      </div>
    </section>;
}